<template lang="pug">
  #points
    WtTile(ancestor vertical)
      BLoading(:active.sync="fullPageLoader" :is-full-page="true")
      WtTile(parent vertical)
        WtTile(child)
          .total-points
            BIcon.yellow-star(icon='star' size="is-medium")
            |Total Points Earned: {{totalPoints}}
            .points-since Since {{totalPointsSince}}
          //- .is-flex.chart-title-container
          //-   WtTitle(:card-title="false" :card-title-large="true") Points over time
          //-   .time-frame-dropdown-container
          //-     .time-frame-description Time Frame
          //-     BDropdown(aria-role='list' v-model="timeFrame" scrollable)
          //-       template(#trigger='{ active }')
          //-         BButton(:label="timeFrameToLabel[timeFrame] || 'Choose'" :icon-right="active ? 'menu-up' : 'menu-down'")
          //-       template
          //-         BDropdownItem(
          //-           key="week"
          //-           aria-role="listitem"
          //-           value="week"
          //-         ) Last Week
          //-         BDropdownItem(
          //-           key="month"
          //-           aria-role="listitem"
          //-           value="month"
          //-         ) Last Month
          //- LineChart(
          //-   :chart-data="pointsData"
          //-   :yAxesTicksMin=0
          //-   :yAxesTicksMax=100
          //-   :yAxesTicksStepSize=20
          //-   :yAxesTicksPadding=10
          //-   yAxesTicksFontColor="#9C97A0"
          //-   :yAxesGridLinesBorders="false"
          //-   :xAxesTicksPadding=10
          //-   xAxesTicksFontColor="#9C97A0"
          //-   :xAxesTicksOffset="true"
          //- )
          //- WtButtonToggle(
          //-   :activeToggle="activeToggle[pointsTableMode]"
          //-   @toggleOn="setPointsTableMode"
          //-   leftButtonText="Total Points"
          //-   rightButtonText="Points Log"
          //- )
          //- div(v-if="pointsTableMode==='totalPoints'")
          //-   WtEntityTable#log-points-table(
          //-     key="logPointsTable"
          //-     title=""
          //-     has-large-title
          //-     :data="totalPointsData"
          //-     :pagination-object="totalPointsPaginationData"
          //-     default-sort-field="pointsAwardedForDate"
          //-     empty-message="No points awarded yet."
          //-     :showEmptyMessage="pointsLoaded && _.isEmpty(points)"
          //-   )
          //-     BTableColumn(
          //-       field="pointsAwardedFor"
          //-       label="Category"
          //-       sortable
          //-       v-slot="column"
          //-     )
          //-       | {{ column.row.pointsAwardedFor }}
          //-     BTableColumn(
          //-       field="pointsAmount"
          //-       label="Total Points Earned"
          //-       sortable
          //-       v-slot="column"
          //-     )
          //-       | {{ column.row.pointsAmount }}
          BDropdown.points-log-filter-dropdown(aria-role='list' v-model="pointsLogFilter" scrollable)
            template(#trigger='{ active }')
              BButton(
                :label="pointsLogFilter ?  pointsLogFilterOptions.find(filter => filter.name === pointsLogFilter).label : 'Filter By:'" 
                :icon-right="active ? 'menu-up' : 'menu-down'"
                )
            template(v-for="pointLogFilter in pointsLogFilterOptions")
              BDropdownItem(
                :key="pointLogFilter.name"
                aria-role='listitem'
                :value="pointLogFilter.name"
              ) {{ pointLogFilter.label }}
          WtEntityTable#points-table(
            key="points-table"
            title=""
            has-large-title
            :fetch-action="fetchAction"
            :data="points"
            :pagination-object="pointsPagination"
            default-sort-field="pointsAwardedForDate"
            :filter="pointsLogFilter"
            empty-message="No points awarded yet."
            :showEmptyMessage="pointsLoaded && _.isEmpty(points)"
            @fetchActionResponse="updateData"
          )
            BTableColumn(
              field="pointsAwardedForDate"
              label="Date"
              sortable
              v-slot="column"
            )
              | {{ date(column.row.pointsAwardedForDate, "DATE_FORMAT_SLASH").formatted }}
            BTableColumn(
              field="pointsAwardedFor"
              label="Category"
              sortable
              v-slot="column"
            )
              | {{ column.row.pointsAwardedFor }}
            BTableColumn(
              field="pointsAmount"
              label="Total Points Earned"
              sortable
              v-slot="column"
            )
              | {{ column.row.pointsAmount }}


</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtButton from "@/components/WtButton/WtButton";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import WtEntityTable from "@@/WtEntityTable/WtEntityTable";
import LineChart from "@/charts/LineChart";
import { fetchAllMixin } from "@/mixins/fetchAllMixin";
import { dateUtilityMixin } from "../mixins/dateUtilityMixin";
import WtButtonToggle from "@@/WtButtonToggle/WtButtonToggle";
import moment from "moment";

export default {
  name: "Points",

  components: {
    WtButton,
    WtTile,
    WtTitle,
    WtEntityTable,
    LineChart,
    WtButtonToggle
  },

  mixins: [fetchAllMixin, dateUtilityMixin],

  data() {
    return {
      page: "Points",
      points: [],
      pointsPagination: {},
      timeFrame: "week",
      timeFrameToLabel: {
        week: "Last Week",
        month: "Last Month"
      },
      pointsData: {
        datasets: [
          {
            backgroundColor: "transparent",
            borderColor: "#DEB21C",
            data: [20, 45, 80, 60, 70, 10, 30],
            lineTension: 0,
            pointBorderWidth: 3,
            pointRadius: 10,
            pointBackgroundColor: "#F5DE99",
            pointHoverRadius: 10,
            pointHoverBackgroundColor: "#DEB21C"
          }
        ],
        labels: [
          "Sun 8",
          "Mon 9",
          "Tue 10",
          "Wed 11",
          "Thu 12",
          "Fri 13",
          "Sat 14"
        ]
      },
      pointsTableMode: "totalPoints",
      activeToggle: {
        totalPoints: "left",
        pointsLog: "right"
      },
      totalPointsData: [
        {
          pointsAwardedFor: "Steps/Activities",
          pointsAmount: 24
        },
        {
          pointsAwardedFor: "Photo Upload",
          pointsAmount: 64
        },
        {
          pointsAwardedFor: "Journal Entry",
          pointsAmount: 14
        },
        {
          pointsAwardedFor: "Nutrition Entry",
          pointsAmount: 23
        },
        {
          pointsAwardedFor: "Water Entry",
          pointsAmount: 14
        },
        {
          pointsAwardedFor: "Mindfulness Entry",
          pointsAmount: 50
        },
        {
          pointsAwardedFor: "Mood Entry",
          pointsAmount: 60
        },
        {
          pointsAwardedFor: "Sleep Entry",
          pointsAmount: 100
        },
        {
          pointsAwardedFor: "Heart Rate Entry",
          pointsAmount: 24
        },
        {
          pointsAwardedFor: "Weight Entry",
          pointsAmount: 32
        },
        {
          pointsAwardedFor: "Question Answered",
          pointsAmount: 12
        }
      ],
      totalPointsPaginationData: {
        count: 11,
        total: 11,
        perPage: 11,
        totalPages: 1
      },
      pointsLogFilter: null
    };
  },

  computed: {
    ...mapGetters("members", ["pointsLoaded"]),

    pointsLogFilterOptions() {
      // TODO: put the exact database field name for the labels that contain ?

      let mainMetrics = [
        {
          label: "Steps/Activities",
          name: "entries"
        },
        {
          label: "Photo Upload",
          name: "photos"
        },
        {
          label: "Journal Entry",
          name: "blog"
        },
        {
          label: "Question Answered",
          name: "question"
        },
        {
          label: "Admin Given",
          name: "admin given"
        }
      ];
      let wellnessMetrics = [
        {
          label: "Nutrition Entry",
          name: "nutrition"
        },
        {
          label: "Water Entry",
          name: "water"
        },
        {
          label: "Mindfulness Entry",
          name: "mindfulness"
        },
        {
          label: "Mood Entry",
          name: "mood"
        },
        {
          label: "Sleep Entry",
          name: "sleep"
        },
        {
          label: "Heart Rate Entry",
          name: "heart"
        },
        {
          label: "Weight Entry",
          name: "weight"
        }
      ];
      return this.$auth.user().program.isWellnessMetricsOn
        ? [...mainMetrics, ...wellnessMetrics]
        : mainMetrics;
    },

    fullPageLoader() {
      return !this.pointsLoaded;
    },

    totalPoints() {
      return this.$auth.user().memberData.totalPoints;
    },

    totalPointsSince() {
      return moment.unix(this.$auth.user().registeredDate).format("LL");
    }
  },
  watch: {
    timeFrame() {
      // console.log('timeFrame', this.timeFrame)
      // TO DO: fetch new data when changing time frame
    },

    pointsLogFilter() {
      const payload = {
        filter: this.pointsLogFilter
      };

      this.fetchAction(payload).then(response => {
        this.$emit("fetchActionResponse", response);
        this.points = response.data;
        this.pointsPagination = response.pagination;
      });
    }
  },

  async mounted() {
    const response = await this.fetchPoints({
      memberId: this.$auth.user().id
    });
    this.points = response.data;
    this.pointsPagination = response.pagination;
  },

  methods: {
    ...mapActions("members", ["fetchPoints"]),
    ...mapActions("pages", [
      "fetchAllPagePoints",
      "setPageLoading",
      "setPageLoaded"
    ]),
    ...mapActions(["snackBar"]),

    async fetchActionTotalPoints(payload) {
      return await this.fetchTotalPoints({
        memberId: this.$auth.user().id,
        ...payload
      });
    },

    async fetchAction(payload) {
      return await this.fetchPoints({
        memberId: this.$auth.user().id,
        ...payload
      });
    },

    updateData($event) {
      this.points = $event.data;
      this.pointsPagination = $event.pagination;
    },
    setPointsTableMode(activeToggle) {
      this.pointsTableMode =
        activeToggle === "left" ? "totalPoints" : "pointsLog";
    }
  }
};
</script>

<style lang="sass" scoped>
#points
  .total-points
    font-size: $size-6
    color: $grey
    display: flex
    align-content: center
    flex-wrap: wrap
    .yellow-star
      color: $yellow-dark
      line-height: 2rem
      margin-right: 10px
    .points-since
      padding-left: $block-spacing
  .time-frame-description
    font-size: $size-7
    color: $grey
    padding: 0 0 0.5rem 0.5rem
  .chart-title-container
    justify-content: space-between
    align-items: flex-end
    .time-frame-dropdown-container
      margin-bottom: 1.5rem
  .points-table-mode-switch-container
    margin-top: $block-spacing
    background-color: $grey-light
    width: 244px
    padding: 2px
    box-sizing: border-box
    border-radius: 12px
    button
      width: 120px
      background-color: transparent
      color: $grey
      font-weight: $weight-bold
    button:disabled
      background-color: $white
      color: $black
      opacity: 1 !important
  #points-table, #log-points-table
    /deep/ table
      table-layout: fixed
    /deep/ table .th-wrap
      width: 100%
    /deep/ table .th-wrap span:not(.icon)
      width: 100%
    /deep/ table thead tr th:nth-child(2)
      text-align: center
    /deep/ table tbody tr td:nth-child(2)
      text-align: center
    /deep/ table thead tr th:last-of-type
      text-align: end
    /deep/ table tbody tr td:last-of-type
      text-align: end
  .points-log-filter-dropdown
    float: right
    transform: translate(0, -40px)
    z-index: 2
  @media (max-width: 600px)
    .total-points
      flex-direction: column
      align-items: flex-start
      .yellow-star
        margin-right: 0
      .points-since
        padding-left: 0
    .points-log-filter-dropdown
      float: right
      transform: translate(0, 0)
      z-index: 2
</style>
